// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/survival-preparedness.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/survival-preparedness/survival-preparedness.js';

mount([g0]);
